export default function FindApiFix() {
    if (typeof window.FindApi === 'undefined') window.FindApi = null;
}
